
import { post, get } from './apicore'
export async function getPoolIntroById(poolId) {
  return get(`${process.env.REACT_APP_API_ENDPOINT}/pools/${poolId}/intro`, null, null)
}

export async function updatePoolIntroById(poolId, data) {
  return post(`${process.env.REACT_APP_API_ENDPOINT}/pools/${poolId}/intro`, null, data, null)
}

export async function getPoolIntroByIdFromJSON(poolId) {
  return get(`${process.env.REACT_APP_JSON_ENDPOINT}/pools/${poolId}/intro.json`, null, null, 1000)
}

export async function getPoolByIdFromJSON(poolId) {
  return get(`${process.env.REACT_APP_JSON_ENDPOINT}/pools/${poolId}.json`, null, null, 1000)
}